type ChipTone = 'done' | 'pending' | 'idle';

interface StageChipProps {
  label: string;
  tone: ChipTone;
}

const TONE_CLASSES: Record<ChipTone, string> = {
  done: 'bg-green-100 text-green-800',
  pending: 'bg-amber-100 text-amber-700',
  idle: 'bg-muted text-muted-foreground',
};

/** A single stage sub-step pill (e.g. "Created", "Repo", "Live"). */
export function StageChip({ label, tone }: StageChipProps) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${TONE_CLASSES[tone]}`}>
      {tone === 'done' && (
        <svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
      {label}
    </span>
  );
}
